export default "__VITE_ASSET__CvTwdf8X__"